export class Usuario {
    public idCompania: string;
    public idUsuario: string;
    public nombreUsuario: string;
    public nombreCompania: string;
    public identificacion: string;
    public tipoUsuario: string;
    public email: string;
    public contrasena: string;
    public estado: string;
}